import request from '@/utils/request'

/**
 * 获取消息列表
 * @param {*} data 
 */
function getNotifyPageList(data){
  return request({
    url: '/notify/getNotifyPageList',
    method: 'post',
    data
  })
}
/**
 * 新增
 * @param {*} data 
 */
function createNotice(data){
  return request({
    url: '/notify/create',
    method: 'post',
    data
  })
}
/**
 * 导出
 * @param {*} params 
 */
function exportNotice(data) {
  return request({
    url: '/notify/export',
    method: 'post',
    responseType: 'arraybuffer',
    data
  })
}

function getAppList(data) {
  return request({
    url: '/appUser/list',
    method: 'post',
    data
  })
}
export {
  getNotifyPageList,
  createNotice,
  exportNotice,
  getAppList
}